import React from 'react';

const Select = ({cuenta, handleChangePara}) => {
    return ( 
        <div className="option">
            <p
                onClick={() => handleChangePara(cuenta._id, cuenta.nombre)}
            >{cuenta.nombre}</p>
        </div>
     );
}
 
export default Select;